import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { EditButtonsContainer } from "../../styled";
import { EditFeatureGeometryActions } from "./components/EditFeatureGeometryActions";
import { ControlsProps } from "./types";
import { ToggleGeometryModeButton } from "./components/ToggleGeometryModeButton";
import { GeometryEditorMode } from "../../../../ducks/geometryEditor/geometryEditor";

export const PolylineControls: FC<ControlsProps> = ({ mode, feature }) => {
  const { t } = useTranslation("featureCard");

  return (
    <EditButtonsContainer>
      <ToggleGeometryModeButton
        mode={mode}
        selectMode={GeometryEditorMode.Edit}
        kind={"geom_poly_vertex"}
        title={t("editVertices")}
      />
      <EditFeatureGeometryActions feature={feature} mode={mode} />
      <ToggleGeometryModeButton
        mode={mode}
        selectMode={GeometryEditorMode.Transform}
        kind={"geom_move"}
        title={t("move")}
      />
    </EditButtonsContainer>
  );
};
